import { render, staticRenderFns } from "./create-edit-user.vue?vue&type=template&id=952d6108&scoped=true"
import script from "./create-edit-user.vue?vue&type=script&lang=js"
export * from "./create-edit-user.vue?vue&type=script&lang=js"
import style0 from "./create-edit-user.vue?vue&type=style&index=0&id=952d6108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952d6108",
  null
  
)

export default component.exports